import * as React from "react";
import AppBar from "@mui/material/AppBar";
import { Typography, Grid, Link } from "@mui/material";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import { ReactComponent as IconEasyPayLogoDashboard } from "../../../icons/epLogoDashboardNew.svg";
import { useNavigate } from "react-router-dom";
import RouteBasedButtonGroup from "../../general/RouteBasedButtonGroup";
import { useSelector, useDispatch } from "react-redux";
import { selectUserInfo, setIsTransactionDataFiltered } from "../../../features/userInfo/userInfoSlice";
import { setShouldLogout } from "../../../features/global/globalDataSlice";
import colors from "../../colors";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import NotificationsIcon from "@mui/icons-material/Notifications";
import HelpIcon from "@mui/icons-material/Help";
import LogoutIcon from "@mui/icons-material/Logout";
import ArticleIcon from "@mui/icons-material/Article";
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { texts } from "../../general/texts";

const ResponsiveAppBar = (props) => {
  const dispatch = useDispatch();
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const navigate = useNavigate();
  const userInfo = useSelector(selectUserInfo);

  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  const onClickUrl = (url) => {
    return () => openInNewTab(url);
  };

  const profileMenu = [
    {
      title: texts["placeholder-personal-data"],
      icon: <PersonIcon color="warning" />,
      url: () => {
        navigate("/myProfile");
      },
    },
    {
      title: texts["placeholder-security"],
      icon: <LockIcon color="warning" />,
      url: () => {
        navigate("/security");
      },
    },
    userInfo.accountType !== 3 && 
    {
      title: texts["placeholder-notification"],
      icon: <NotificationsIcon color="warning" />,
      url: () => {
        navigate("/notifications");
      },
    },
      userInfo.showInviteFriend && 
        {
          title: texts["title-invite-friend"],
          icon: <GroupAddIcon color="warning" />,
          url: () => {
            navigate("/inviteFriend");
          },
        },
    {
      title: texts["placeholder-help-support"],
      icon: <HelpIcon color="warning" />,
      url: () => {
        navigate("/popularQuestions");
      },
    },
    {
      title: texts["title-terms-and-conditions"],
      icon: <ArticleIcon color="warning" />,
      url: onClickUrl(props.termsAndConditionsUrl),
    },
    {
      title: texts["button-logout"],
      icon: <LogoutIcon color="warning" />,
      url: () => {
        dispatch(setShouldLogout(true));
      },
    },
  ];

  const displayPagesBasedOnAccountType = () => {
    if (userInfo.accountType == 1) {
      return [
        { display: texts["title-home"], value: "dashboard" },
        { display: texts["title-topup"], value: "topUp" },
        { display: texts["title-payments"], value: "onpayments" },
        { display: texts["title-transfer"], value: "p2p" },
        { display: texts["title-history"], value: "history" },
        { display: texts["title-events"], value: "events" },
      ];
    } 
    else if (userInfo.accountType == 3){
      return [
        { display: texts["title-home"], value: "dashboard" },
        { display: texts["title-payments"], value: "onpayments" },
        { display: texts["title-history"], value: "history" },
        { display: texts["title-events"], value: "events" },
      ];
    }
    else if (userInfo.accountType == 2){
      return [
        { display: texts["title-home"], value: "dashboard" },
        { display: texts["title-topup"], value: "topUp" },
        { display: texts["title-payments"], value: "onpayments" },
        { display: texts["title-history"], value: "history" },
        { display: texts["title-events"], value: "events" },
      ];
    }
  };

  

  const selectedButtonStyle = {
    color: colors.white,
    width: "5.5rem",
    height: "1.7rem",
    fontFamily: "GerberaLight",
    textTransform: "none",
    backgroundColor: colors.hoverOrange,
    borderRadius: "20px",
    "&:hover": {
      backgroundColor: colors.hoverOrange,
    },
  };

  const defaultButtonStyle = {
    borderRadius: "20px",
    width: "5.5rem",
    height: "1.7rem",
    fontFamily: "GerberaLight",
    textTransform: "none",
    color: colors.white,
    "&:hover": {
      borderRadius: "20px",
      backgroundColor: colors.hoverOrange,
    },
  };

  const selectedButtonStyleMenu = {
    color: colors.white,
    textTransform: "none",
    width: "8rem",
    fontFamily: "GerberaLight",
    background: colors.gradientOrange,
    borderRadius: "0px",
    "&:hover": {
      backgroundColor: colors.lightGray,
    },
  };
  const defaultButtonStyleMenu = {
    borderRadius: "5px",
    textTransform: "none",
    color: colors.darkBlue,
    fontFamily: "GerberaLight",
    width: "8rem",
    backgroundColor: colors.white,
    "&:hover": {
      borderRadius: "0px",
      backgroundColor: colors.lightGray,
    },
  };

  const getValueFromButtonGroup = (value) => {
    dispatch(setIsTransactionDataFiltered(false))
    navigate(value);
  };

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar
      position="sticky"
      sx={{
        background: colors.gradientOrange,
        boxShadow: "none",
        height: "110%",
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ paddingTop: "1%" }}>
          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
              PaperProps={{
                style: {
                  width: "8rem",
                  height: "12.5rem",
                  background: colors.white,
                  color: colors.darkBlue,
                  borderRadius: "0px 20px 20px 20px",
                },
              }}
            >
              <RouteBasedButtonGroup
                routeEndpointPosition={0}
                selectedButtonStyle={selectedButtonStyleMenu}
                defaultButtonStyle={defaultButtonStyleMenu}
                state={displayPagesBasedOnAccountType()}
                sendValue={getValueFromButtonGroup}
              />
            </Menu>
          </Box>
          <Grid
            container
            item
            md={2}
            justifyContent={"left"}
            sx={{ "@media (max-width: 899px)": { justifyContent: "center" } }}
          >
            <Link component="button" onClick={() => navigate("/dashboard")}>
              <IconEasyPayLogoDashboard />
            </Link>
          </Grid>
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex" },
              justifyContent: "center",
            }}
          >
            <Grid container columnSpacing={1} justifyContent={"center"}>
              <RouteBasedButtonGroup
                routeEndpointPosition={0}
                selectedButtonStyle={selectedButtonStyle}
                defaultButtonStyle={defaultButtonStyle}
                state={displayPagesBasedOnAccountType()}
                sendValue={getValueFromButtonGroup}
              />
            </Grid>
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton
                onClick={handleOpenUserMenu}
                sx={{
                  width: "11rem",
                  borderRadius: "10px",
                  "@media (max-width: 899px)": { width: "4rem" },
                }}
              >
                <Avatar
                  sx={{ backgroundColor: "white", color: colors.gray }}
                  alt={userInfo.name}
                  src="/static/images/avatar/2.jpg"
                />
                <Grid display={{ xs: "none", md: "block" }}>
                  <Typography
                    sx={{
                      color: colors.white,
                      fontFamily: "GerberaLight",
                      pl: 1,
                    }}
                  >
                    {userInfo.name}
                  </Typography>{" "}
                </Grid>
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: "60px" }}
              id="simple-menu"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              PaperProps={{
                style: {
                  width: "15rem",
                  color: colors.darkBlue,
                  borderRadius: "20px 0px 20px 20px",
                },
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {profileMenu.filter(Boolean).map((menu, index) => (
                <MenuItem onClick={menu?.url} key={index}>
                  <Grid item md={3} xs={3}>
                    {menu?.icon}
                  </Grid>
                  <Grid item md={9} xs={9}>
                    <Typography
                      sx={{ fontSize: "0.8rem", fontFamily: "GerberaMedium" }}
                    >
                      {menu?.title}
                    </Typography>
                  </Grid>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default ResponsiveAppBar;
